module.exports = __webpack_public_path__ + "media/src/images/favicons/apple-touch-icon-72x72-8628043835f488a2b9324550c65418e2.png";